import { mergeStyleSets, getTheme, FontSizes, FontWeights, NeutralColors, IButtonStyles } from "@fluentui/react";
const theme = getTheme();

export const ButtonStyle = mergeStyleSets({
  button: {
    background: "transparent",
    color: "#FFF",
    border: "0",
    height: "auto",
    ">span": {
      display: "flex",
      height: "60px",
      alignItems: "center",
      gap: "8px",
      i: {
        width: "28px",
        height: "28px",
        lineHeight: "28px"
      }
    }
  },
  CompoundButton: {
    background: "transparent",
    color: NeutralColors.white,
    border: "0",
    height: "auto",
    paddingTop: "0",
    paddingBottom: "0",
    minHeight: "0",
    minWidth: "206px",
    "span": {
      color: "#fff!important",
    },
    "&:hover": {
      background: NeutralColors.gray170,
      "span": {
        color: NeutralColors.white,
      },
    },
    "&:active": {
      background: NeutralColors.gray140,
      "span": {
        color: NeutralColors.white,
      },
    },
    ">span": {
      display: "flex",
      height: "60px",
      alignItems: "center",
      gap: "8px",
      span: {
        color: "#fff",
      },
      i: {
        width: "28px",
        height: "28px",
        lineHeight: "28px"
      }
    }
  },
  messageBarButton: {
    border: "1px solid #8A8886",
    background: "#ffff",
    padding: "2px 20px",
    height: "24px"
  },
  ManagementAccountButton: {
    display: "flex",
    height: "32px",
    padding: "6px 20px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: "2px",
    border: "1px solid #8A8886",
    background: "#FFF"
  },
  transparentButton: {
    display: "flex",
    height: "32px",
    padding: "6px 20px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    background: "transparent"
  },
  LinkButton: {
    color: theme.palette.blue,
    fontSize: FontSizes.size14,
    fontSeight: FontWeights.regular,
    lineHeight: "20px"
  },
  TableActionButton: {
    color: theme.palette.blue,
    fontSize: FontSizes.size14,
    fontSeight: FontWeights.regular,
    lineHeight: "20px",
    padding: "0!important",
    minWidth: "auto",
    border: "0",
    background: "transparent",
    "&:hover": {
      color: theme.palette.blue,
    },
    fontWeight: 400
  },
  TableActionDisabledButton: {
    color: NeutralColors.gray130,
    fontSize: FontSizes.size14,
    fontSeight: FontWeights.regular,
    lineHeight: "20px",
    padding: "0!important",
    minWidth: "auto",
    border: "0",
    background: "transparent",
    "&:hover": {
      color: NeutralColors.gray130,
    }
  }
});

export const ButtonStyles120 = {
  root: {
    padding: "6px 20px!important",
  },
  flexContainer: {
    width: 120,
    height: 20,
  },
  label: {
    lineHeight: 20,
  }
};

export const ButtonStyles160 = {
  root: {
    padding: "6px 20px!important",
  },
  flexContainer: {
    // width: 160,
    height: 20,
  },
  label: {
    lineHeight: 20,
  }
};

export const ButtonStyles80 = {
  root: {
    padding: "6px 20px!important",
  },
  flexContainer: {
    minWidth: 80,
    height: 20,
  },
  label: {
    lineHeight: 20,
  }
};

export const buttonStyles = { root: { marginRight: 8 } };

export const buttonMarginRight16Styles = { root: { marginRight: 16 } };

export const buttonLabel400 = mergeStyleSets({
  label: {
    fontWeight: 400
  }
});
